import TemplatePhytophagy from './template-phytophagy';

export default TemplatePhytophagy;